import * as server from '../../server';

export const getGameExportHistory = async (params) => {
    let page = 1;
    let allTransactions = [];

    const getGameHistory = async () => {
        const { data: { results, totalRecords } } = await server.getGameHistory({ ...params, page });

        allTransactions = [...allTransactions, ...results];

        if (allTransactions.length < totalRecords) {
            page++;

            return getGameHistory();
        }
    };

    await getGameHistory();

    return allTransactions;
};
